export default function RegistrationFinished() {
    return (
        <div className="grid place-items-center">
        <section className="py-12 bg-gray-50 overflow-hidden md:py-20 lg:py-24">
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                <div className="relative">
                    <img
                        className="mx-auto h-8"
                        src="https://cdn.vault56.com/images/56_logo.png"
                        alt="vault56"
                    />
                    <blockquote className="mt-10">
                        <div className="max-w-3xl mx-auto text-center text-2xl leading-9 font-medium text-gray-900">
                            <p>Thank you for registering an account at vault56</p>
                            <p className="mt-5">
                                We have sent a validation email to you. Check your email inbox and make sure our email has not ended up in your spam folder. Once you have validated your email address, you are ready to start using vault56.
                            </p>
                        </div>
                        <footer className="mt-8">
                            <div className="md:flex md:items-center md:justify-center">
                                <div className="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                                    <div className="text-base font-medium text-gray-500">The vault56 team</div>
                                </div>
                            </div>
                            <div className="md:flex md:items-center md:justify-center pt-2"><a href="https://secure.vault56.com">Go to vault56 login page</a></div>
                        </footer>
                    </blockquote>
                </div>
            </div>
        </section>
        </div>
    )
}
